// components/publisher/PublisherInsights.jsx
import React, { useEffect } from 'react';
import { usePublisherInsights } from '../../contexts/PublisherInsightsContext';
import { Loader2 } from 'lucide-react';
import PublisherInsightsContent from './PublisherInsightsContent';

const LoadingState = () => (
    <div className="flex flex-col items-center justify-center h-96">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
        <p className="mt-4 text-gray-600">Loading publisher insights...</p>
    </div>
);

const ErrorState = ({ error, onRetry }) => (
    <div className="flex flex-col items-center justify-center h-96">
        <div className="text-red-600 mb-4">Error loading insights: {error}</div>
        <button
            onClick={onRetry}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
            Retry
        </button>
    </div>
);

export default function PublisherInsights() {
    const { insights, loading, error, fetchInsights } = usePublisherInsights();

    // Fetch on mount if not already loaded
    useEffect(() => {
        if (!insights && !loading && !error) {
            fetchInsights();
        }
    }, [insights, loading, error, fetchInsights]);

    if (loading) {
        return <LoadingState />;
    }

    if (error) {
        return <ErrorState error={error} onRetry={fetchInsights} />;
    }

    if (!insights) {
        return (
            <div className="p-8">
                <div className="bg-white rounded-lg shadow p-6 text-center space-y-3">
                    <p className="text-gray-700">No publisher insights loaded yet.</p>
                    <button
                        onClick={fetchInsights}
                        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                    >
                        Load Publisher Insights
                    </button>
                </div>
            </div>
        );
    }

    return <PublisherInsightsContent insights={insights} />;
}
